import { TrendingUp, TrendingDown, Minus } from "lucide-react";
import { cn } from "@/lib/utils";

export function Sparkline({ points = [], width = 140, height = 36, testId = "sparkline" }) {
  const vals = points.map((p) => p.overall ?? p);
  if (vals.length < 2) return <div className="text-[10px] text-muted-foreground" data-testid={testId}>Trend builds after 2 snapshots</div>;
  const min = Math.min(...vals), max = Math.max(...vals), span = max - min || 1;
  const step = width / (vals.length - 1);
  const pts = vals.map((v, i) => [i * step, height - 3 - ((v - min) / span) * (height - 6)]);
  const d = pts.map(([x, y], i) => `${i ? "L" : "M"}${x.toFixed(1)},${y.toFixed(1)}`).join(" ");
  const delta = vals[vals.length - 1] - vals[0];
  const tone = delta > 0 ? "text-emerald-600 dark:text-emerald-400" : delta < 0 ? "text-rose-600 dark:text-rose-400" : "text-muted-foreground";
  const stroke = delta > 0 ? "#10b981" : delta < 0 ? "#f43f5e" : "#94a3b8";
  const Icon = delta > 0 ? TrendingUp : delta < 0 ? TrendingDown : Minus;
  return (
    <div className="flex items-center gap-2" data-testid={testId}>
      <svg width={width} height={height} className="overflow-visible">
        <defs><linearGradient id={`g-${testId}`} x1="0" x2="0" y1="0" y2="1"><stop offset="0%" stopColor={stroke} stopOpacity="0.25" /><stop offset="100%" stopColor={stroke} stopOpacity="0" /></linearGradient></defs>
        <path d={`${d} L${width},${height} L0,${height} Z`} fill={`url(#g-${testId})`} />
        <path d={d} fill="none" stroke={stroke} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
        <circle cx={pts[pts.length - 1][0]} cy={pts[pts.length - 1][1]} r="3" fill={stroke} />
      </svg>
      <span className={cn("text-xs font-semibold tabular-nums inline-flex items-center gap-0.5", tone)} data-testid={`${testId}-delta`}><Icon size={12} />{delta > 0 ? "+" : ""}{delta} pts</span>
    </div>
  );
}
